export default class Favourites {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Favourites;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-toggle-save', function(e) {
			e.preventDefault();
			self.toggleSave($(this).data('listing-id'), $(this).data('refresh'));
		});
	}

	toggleSave(listingId, refresh) {
		const self = this;

		oc.progressBar.show();

		oc.ajax('savedListings::onToggleSave', {
	        data: {
	        	listing_id: listingId
	        },
	        success: function(data, textStatus, jqXHR) {
	            this.success(data, textStatus, jqXHR);

	            oc.progressBar.hide();

	            $('.js-business-listings-saved-count').text(data.count);

	            if (data.count == 0) {
					$('.js-business-listings-saved-count').hide();
	            } else {
	            	$('.js-business-listings-saved-count').show();
	            }

	            if (data.exists != true && refresh == true) {
	            	location.reload();
	            }

	            let $links = $('.js-toggle-save[data-listing-id="' + listingId + '"]', document);

	            $links.each(function() {
	    			let $link = $(this),
	    				addText = $link.data('saved-add-text'),
	    				removeText = $link.data('saved-remove-text'),
	    				$innerText = $link.find('.js-toggle-save-text'),
	    				$textEl = ($innerText.length > 0 ? $innerText : $link);

		            if (data.exists) {
		            	$textEl.html(removeText);
		            	$link.addClass('is-saved');
		            } else {
		            	$textEl.html(addText);
		            	$link.removeClass('is-saved');
		            }
	            });
	        }
	    });
	}
}
